export default "__VITE_ASSET__3sC$S9d4__"